// removed by extract-text-webpack-plugin
module.exports = {"logo-upload-section":"_1SKq","heading":"_3_97","helper-text":"_2-yG","upload-section":"_1Hji","upload-button":"_hNLa","upload-button-label":"_zmgd","selected-logo":"_2rfF","selected-logo-name":"_14zP","fileup":"_-FLk","upload-logo":"_2ZOE","close-button":"_1Aa_","logo-upload-input":"_3xFS","error":"_32TX","button-container":"_2X0t","reset-button-container":"_2K3o"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/merchantLogoSection/style.css
// module id = GcWV
// module chunks = 4